import Validator from 'validatorjs';
import { RECAPTCHA_SITEKEY } from '../helpers/constants';

Validator.register(
  'custom_url',
  value => {
    const urlPattern = /^(https?:\/\/|www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
    return urlPattern.test(value);
  },
  'It should be a valid URL'
);

const formRules = {
  name: 'required|string|min:3',
  country: 'required|string',
  location: 'present|string',
  branch: 'required|string',
  motive: 'required|string',
  product: 'required|string|min:5',
  use: 'required|string',
  email: 'required|email',
  details: 'required|min:10',
  category: 'required',
  typeOfRequest: 'required|string',
  company_website: 'required|custom_url|min:5|max:70' 
};

const errorMessages = {
  required: NFT.I18n.error_required_default,
  min: NFT.I18n.error_min,
  email: NFT.I18n.error_email_format,
  regex: NFT.I18n.error_job_email
};

const customFieldNames = {
  name: NFT.I18n.single_info_request?.name.toLowerCase(),
  email: NFT.I18n.single_info_request?.email.toLowerCase(),
  country: NFT.I18n.single_info_request?.country.toLowerCase(),
  location: NFT.I18n.single_info_request?.city.toLowerCase(),
  branch: NFT.I18n.single_info_request?.branch.toLowerCase(),
  typeOfRequest: NFT.I18n.single_info_request?.type_of_request.toLowerCase(),
  details: NFT.I18n.single_info_request?.message.toLowerCase(),
  job_title: NFT.I18n.job_title?.toLowerCase(),
  job_email: NFT.I18n.job_email?.toLowerCase(),
  phone: NFT.I18n.single_info_request?.phone.toLowerCase()
}

// field has to be object {key: value}
export const validateField = (field = {}, clean) => {
  const [ key ] = Object.keys(field);

  // accept empty value for phone field
  if (key === 'phone' || key === 'company') return clean ? null : { errorCount: 0 }

  if (typeof field[key] === 'object') {
    field[key] = field[key].value || field[key].slug || ''
  }

  const rule = {};
  rule[key] = formRules[key];
  const validation = new Validator(field, rule, errorMessages);
  validation.setAttributeNames(customFieldNames);
  validation.passes();

  if (clean) return validation.errorCount ? validation.errors.errors[key][0] : null
  return validation
};

export const validateForm = (form = {}, excludedFields = [], customRules) => {
  const rules = { ...(customRules || formRules) };
  excludedFields.forEach(field => delete rules[field]);
  const validation = new Validator(form, rules, errorMessages);
  validation.setAttributeNames(customFieldNames);
  validation.passes();
  return validation;
};

export const flattenErrors = validation => Object.entries(validation.errors.errors)
  .reduce((acc, [key, value]) => {
    const [error] = value
    acc[key] = error
    return acc
  }, {})

export const renderRecaptcha = (container, callback, formName, type = 'image', size = 'invisible', position = 'bottomright') => {
  if (!container || !callback || !formName ||
    (NFT.recaptchaIds?.hasOwnProperty(formName))) return;
  if (!NFT.recaptchaIds) NFT.recaptchaIds = {};
  const recaptchaConfig = {
    sitekey: RECAPTCHA_SITEKEY,
    badge: position,
    type,
    size,
    callback
  };
  if (window.grecaptcha?.render) {
    NFT.recaptchaIds[formName] = window.grecaptcha.render(container, recaptchaConfig);
  } else {
    document.addEventListener('recaptcha:loaded', () => { NFT.recaptchaIds[formName] = window.grecaptcha.render(container, recaptchaConfig); });
  }
};

export const executeRecaptcha = formType =>
  formType && NFT.recaptchaIds.hasOwnProperty(formType)
    ? window.grecaptcha.execute(NFT.recaptchaIds[formType])
    : false;

export const resetRecaptcha = formType =>
  formType && NFT.recaptchaIds.hasOwnProperty(formType)
    ? window.grecaptcha.reset(NFT.recaptchaIds[formType])
    : false;
